import {Component, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {IClientModel} from "../../../models/clients/clients.model";
import {ClientLocationsModel} from "../../../models/client-locations/client-locations.model";
import {ProvincesService} from "../../../models/provinces/provinces.service";
import {ProvincesModel} from "../../../models/provinces/provinces.model";

@Component({
    selector: 'mailing-address',
    templateUrl: 'mailing-address.template.html',
    exportAs: 'mailing-address'
})
export class MailingAddressComponent {
    @Input('client') @Output('client')
    public client: IClientModel = {
        mailing_location: new ClientLocationsModel(),
        business_location: new ClientLocationsModel(),
    };

    @Input('editMode')
    public editMode = false;

    public provinces = <ProvincesModel[]> [];

    constructor(
        public provincesService: ProvincesService
    ) {
    }

    ngOnInit() {

        this.provincesService.getList()
            .subscribe((res) => {
                this.provinces = res.data;
            });
    }


}



// WEBPACK FOOTER //
// ./src/app/modules/client-forms/mailing-address/mailing-address.component.ts